import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AuthUser from '../pageauth/AuthUser';
import { Toaster, toast } from 'sonner';
import { DescargarApp } from '../componentes/Cuerpos/DescargarApp';
import PuenteApi from '../pageauth/PuenteApi';
import Mensaje from '../Mensaje';
import Config from '../Config';


export const LayoutHome = () => {
  const { getRol, getModule } = AuthUser()
  const { IniciarSession, ObtenerModulos } = PuenteApi()
  const navigate = useNavigate();

  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const { SetMensaje } = Mensaje();
  const [moduloSeleccionado, setModuloSeleccionado] = useState(null);

  useEffect(() => {
    if (getRol() === "client") {
      if (getModule() == "Remotework" || getModule() == "remotework") {
        navigate('/remotework');
      }
      if (getModule() == "Playa" || getModule() == "playa") {
        navigate('/playa');
      }
      if (getModule() == "Shop" || getModule() == "shop") {
        navigate('/shop');
      }
    }
  }, [])

  const [modulos, setModulos] = useState([
    { id: "-1", nombre: "Cargando modulos...", sector: "0", icono: "fa fa-spinner text-4xl text-red-500 mr-2" },
  ]);

  const ObtenerModulos2 = async () => {
    if (getRol() != "admin" && getRol() != "client") {
      try {
        const response = await ObtenerModulos();
        if (response && Array.isArray(response) && response.length > 0) {
          const modulos = response.map((modulo) => ({
            id: modulo.id,
            nombre: modulo.nombre,
            sector: modulo.sector,
            icono: modulo.nombre === 'Remotework' ? 'fas fa-building text-4xl text-red-500 mr-2' : (modulo.nombre === 'Playa' ? 'fas fa-gas-pump text-4xl text-red-500 mr-2' : (modulo.nombre === 'Shop' ? 'fas fa-store text-4xl text-red-500 mr-2' : 'fas fa-question')),
          }));
          setModulos(modulos);
        } else {
          SetMensaje("Error", "No se encontraron modulos", 3000);
          setModulos([{ id: "-1", nombre: "Error al cargar modulos", sector: "0", icono: "fa fa-exclamation-triangle text-4xl text-red-500 mr-2" }]);
        }
      } catch (error) {
        SetMensaje("Error", "Hubo un problema con la solicitud", 3000);
      }
    }
  };

  useEffect(() => {
    ObtenerModulos2();
  }, []);


  const validateFields = () => {
    if (!user || !password) {
      SetMensaje("Error", "Por favor, completa todos los campos", 3000);
      return false;
    }
    if (password.length <= 5) {
      SetMensaje("Error", "La contraseña debe tener más de 5 caracteres", 3000);
      return false;
    }
    return true;
  };

  const Login = async (idmodulo) => {

    const valido = validateFields();
    if (valido) {
      console.log("idmodulo", idmodulo);
      console.log("modulos", modulos);
      const id = Number(idmodulo); // ← aquí

      const modulo = modulos.find(m => m.id === id);

      if (modulo && modulo.nombre && modulo.sector !== undefined) {

        SetMensaje("Cargando", "Iniciando sesión en " + modulo.nombre + modulo.sector + "...");

        IniciarSession(user, password, modulo.nombre, modulo.sector);
      } else {
        SetMensaje("Error", "Módulo seleccionado no es válido", 3000);
      }
    }
  };

  const abrirModulo = (id) => {
    if (id != "-1") {
      setModuloSeleccionado(id);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      Login(moduloSeleccionado);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [moduloSeleccionado, user, password]);

  if (!moduloSeleccionado) {
    return (
      <>
        <Toaster expand visibleToasts={1} />
        <div
          className="d-flex align-items-center justify-content-center min-vh-100"
          style={{ minHeight: '100vh', backgroundColor: '#f9fafb', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <div className="text-center">
            <h1 className="h3 mb-5 fw-bold text-dark" style={{ marginBottom: '3rem', color: '#1f2937' }}>
              Seleccione que módulo del <br />
              sistema que desea abrir
            </h1>

            <div
              className="d-flex flex-wrap justify-content-center gap-4"
              style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '2rem', width: '100%' }}
            >
              {modulos.map((m) => (
                <div
                  key={m.id}
                  onClick={() => abrirModulo(m.id)}
                  className="card shadow-sm align-items-center justify-content-center p-0 border-0 pointer-cursor"
                  style={{
                    width: '10rem',
                    height: '10rem',
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    border: '1px solid #e5e7eb'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.borderColor = '#14b8a6';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)';
                  }}
                >
                  <i
                    className={`${m.icono} mb-3`}
                    style={{ fontSize: '2.25rem', color: '#ef4444', marginBottom: '0.75rem' }}
                  ></i>
                  <p
                    className="mb-0 fw-medium text-secondary"
                    style={{ color: '#374151', fontWeight: 500, margin: 0 }}
                  >
                    {m.nombre} {m.sector > 0 && m.sector}
                  </p>
                </div>
              ))}
            </div>

            <p className="small text-muted mt-5" style={{ color: '#9ca3af', marginTop: '3rem' }}>
              LiderGas - Sistema de gestion ©
            </p>
          </div>
        </div>
      </>
    );
  }

  // --- Vista 2: Login ---
  return (
    <>
      <Toaster expand visibleToasts={1} />
      <div
        className="d-flex align-items-center justify-content-center min-vh-100"
        style={{ minHeight: '100vh', backgroundColor: '#f9fafb', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div
          className="card shadow-lg p-5 d-flex flex-row align-items-center gap-5"
          style={{
            backgroundColor: 'white',
            borderRadius: '0.5rem',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '3rem',
            padding: '2.5rem'
          }}
        >
          {/* Logo */}
          <div className="d-flex flex-column align-items-center text-center">
            <img
              src="/img/logo.webp"
              alt="Sistema de Gestión"
              style={{ height: '60px', width: 'auto', marginBottom: '1rem' }}
            />
          </div>

          {/* Formulario */}
          <div>
            <div className="mb-3">
              <label className="form-label text-secondary small fw-bold" style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', fontWeight: 500, color: '#374151' }}>
                Nombre de Usuario
              </label>
              <input
                type="text"
                className="form-control"
                style={{ width: '250px' }}
                onChange={(e) => setUser(e.target.value)}
                value={user}
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label text-secondary small fw-bold" style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', fontWeight: 500, color: '#374151' }}>
                Contraseña
              </label>
              <input
                type="password"
                className="form-control"
                style={{ width: '250px' }}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                required
              />
            </div>

            <div className="d-flex justify-content-between gap-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button
                className="btn btn-success d-flex align-items-center gap-2"
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                onClick={() => Login(moduloSeleccionado)}
              >
                <i className="fas fa-check-circle"></i> Aceptar
              </button>

              <button
                className="btn btn-danger d-flex align-items-center gap-2"
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                onClick={() => setModuloSeleccionado(null)}
              >
                <i className="fas fa-times-circle"></i> Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}